//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { nanoid } from 'nanoid';

export default {
    inheritAttrs: false,
    props: {
        containerClass: {
            type: String,
            default: undefined,
        },
        errors: {
            type: Array,
            default: undefined,
        },
        id: {
            type: String,
            default: nanoid(),
        },
        label: {
            type: String,
            default: undefined,
        },
        value: {
            type: String,
            default: undefined,
        },
        type: {
            type: String,
            default: 'text',
        },
    },
    computed: {
        elementId() {
            if (this.id) {
                return this.id;
            }

            return nanoid();
        },
        hasErrors() {
            return this.errors && this.errors.length > 0;
        },
    },
};
